jQuery(document).ready(function($){
    const wishlistStorageKey = 'ww-trending-wishlist';

    function getWishlistItems() {
        try {
            const stored = window.localStorage.getItem(wishlistStorageKey);
            const parsed = stored ? JSON.parse(stored) : [];
            return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            return [];
        }
    }

    function saveWishlistItems(items) {
        try {
            window.localStorage.setItem(wishlistStorageKey, JSON.stringify(items));
        } catch (error) {}
    }

    function getButtonKey($button) {
        const productId = String($button.data('product-id') || '').trim();
        const productUrl = String($button.data('product-url') || '').trim();
        return productId || productUrl;
    }

    function collectWishlistPayload($button) {
        const $card = $button.closest('.card-wrapper');
        const $titleLink = $card.find('.card__heading a').first();
        const $image = $card.find('.card__media img').first();
        const $price = $card.find('.price-item--regular').first();
        const key = getButtonKey($button);

        if (!key) return null;

        const url = String($button.data('product-url') || $titleLink.attr('href') || '#').trim();
        const title = String($titleLink.text() || '').trim() || 'Product';
        const price = String($price.text() || '').trim();
        const imgEl = $image[0];
        const originalSrc = imgEl ? imgEl.dataset.wwOriginalSrc : '';
        let image = String(originalSrc || $image.attr('src') || '').trim();
        if (image.startsWith('blob:') || image.startsWith('data:')) {
            image = '';
        }

        return {
            key: key,
            url: url,
            title: title,
            price: price,
            image: image
        };
    }

    function syncWishlistButtons() {
        const items = getWishlistItems();
        const itemMap = new Set(items.map(function(item) { return item && item.key; }));

        $('.swym-add-to-wishlist-view-product').each(function() {
            const $button = $(this);
            const key = getButtonKey($button);
            const isActive = key && itemMap.has(key);
            $button.toggleClass('swym-added', !!isActive);
            $button.attr('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
        });
    }

    // Fallback wishlist behavior for collection/product cards.
    $(document).on('click', '.swym-add-to-wishlist-view-product', function(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const $button = $(this);
        const payload = collectWishlistPayload($button);
        if (!payload) return;

        let items = getWishlistItems();
        const exists = items.some(function(item) { return item.key === payload.key; });
        if (exists) {
            items = items.filter(function(item) { return item.key !== payload.key; });
        } else {
            items.unshift(payload);
        }

        saveWishlistItems(items);
        syncWishlistButtons();
    });

    // Re-apply icon state after async section/filter re-renders.
    const wishlistSyncObserver = new MutationObserver(function() {
        syncWishlistButtons();
    });
    wishlistSyncObserver.observe(document.body, { childList: true, subtree: true });
    syncWishlistButtons();

    setTimeout(() => {
        $('.related-products__list').owlCarousel({
            margin:24,
            dots:true,
            responsive:{
                0:{
                    items:2
                },
                750:{
                    items:3
                }
            }
        })
    }, 3000);
    $(window).on('scroll', function() {
        var heightHeader = $('.announcement-bar-section').height() + $('.header-wrapper').height();
        var heightSticky = $('.header-wrapper').height();
        if ($(this).scrollTop() > heightHeader) {
            $('body').addClass('body-scrolled');
        }
        if ($(this).scrollTop() < heightSticky) {
            $('body').removeClass('body-scrolled');
        }
    });

    if ($(window).width() < 750) {
        var $listMenu = $("header-drawer .menu-drawer__navigation > .list-menu");
        var all_class = $("header-drawer .list-menu li:last-of-type a").attr('class')
        $(".announcement-link a").each(function() {
            var $li = $("<li></li>");
            $li.append($(this).detach());
            $listMenu.append($li);
            $("header-drawer .list-menu a").addClass(all_class)
        });
    }

    $('#HeaderDrawer-brands').click(function () {
        $('.slick-carousel.is_mobile').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
        });

        $('.slick-pagination.is_mobile a').click(function () {
            const slideIndex = $(this).data('slide');
            if (slideIndex !== '') {
                $('.slick-carousel.is_mobile').slick('slickGoTo', slideIndex);
            }
        });
    });

    $(".mega-menu").hover(
        function() {
            $(this).attr('open', '');
            $(this).find('summary').attr("aria-expanded","true");
            if ($(this).find('summary').hasClass("brands")) {
                $('.slick-carousel.is_desktop').slick({
                    infinite: true,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    arrows: false,
                });
                $('.slick-pagination.is_desktop button').click(function () {
                    const slideIndex = $(this).data('slide');
                    if (slideIndex !== '') {
                        $('.slick-carousel').slick('slickGoTo', slideIndex);
                    }
                });
                setTimeout(() => {
                    $('.is_brands.is_desktop').css('opacity', '1');
                }, 500);
            }
        },
        function() {
            $(this).removeAttr('open');
            $(this).find('.summary').attr("aria-expanded","false");
        }

    );

    $('.variant__select-color').change(function(){
        const selectedValue = $(this).val();

        document.querySelectorAll('.variant__list-color input[type="radio"]').forEach((item) => {
            item.removeAttribute('checked');
        });

        if (selectedValue) {
            document.querySelector(`[value='${selectedValue}']`).setAttribute('checked', true);
        }
    })
});
